import React, { useState, useEffect } from "react";
import { useDocument } from "./useDocument";

const useColors = () => {
  const { document: colorsDocument, error: colorsDocumentError } = useDocument(
    "settings",
    "Colors"
  );

  const [colors, setColors] = useState(null);
  const [theme, setTheme] = useState(localStorage.getItem("mode") || "light");

  const updateColors = () => {
    if (colorsDocument) {
      const themeColors =
        theme === "dark"
          ? colorsDocument.DarkScreenTheme
          : colorsDocument.LightScreenTheme;

      if (themeColors) {
        const clickColor = themeColors.clickColor;
        const logoPrimaryColor = themeColors.logoPrimaryColor;
        const logoSecondaryColor = themeColors.logoSecondaryColor;
        const cardBgColor = themeColors.cardBgColor;
        const headingColor = themeColors.headingColor;
        const subheadingColor = themeColors.subheadingColor;
        const SessionPrimarybgColor = themeColors.SessionPrimarybgColor;
        const SessionSecondarybgColor = themeColors.SessionSecondarybgColor;


        setColors({
          clickColor,
          logoPrimaryColor,
          logoSecondaryColor,
          cardBgColor,
          headingColor,
          subheadingColor,
          SessionPrimarybgColor,
          SessionSecondarybgColor
        });
      }
    }
  };

  useEffect(() => {
    if (
      !localStorage.getItem("mode") ||
      localStorage.getItem("mode") === "null" ||
      localStorage.getItem("mode") === ""
    ) {
      localStorage.setItem("mode", "light");
      setTheme("light");
    } else {
      setTheme(localStorage.getItem("mode"));
    }

    const handleStorageChange = () => {
      const storedTheme = localStorage.getItem("mode");
      if (storedTheme) {
        setTheme(storedTheme);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    updateColors();
  }, [theme, colorsDocument]);

  return { colors, colorsDocumentError };
};

export default useColors;
